import { Component, computed, input, InputSignal } from '@angular/core';
import { Social } from '../../shared/interfaces/social.interface';
import { environment } from '../../../environments/environment';
import { TranslatePipe } from '@ngx-translate/core';
import { ItIconComponent } from 'design-angular-kit';

@Component({
  selector: 'drw-socials',
  templateUrl: './socials.component.html',
  imports: [TranslatePipe, ItIconComponent],
})
export class SocialsComponent {
  position: InputSignal<'header' | 'footer'> = input<'header' | 'footer'>('header');

  socials: Social[] = [
    { name: 'SOCIAL.FACEBOOK', icon: 'facebook', url: environment.socials.facebook },
    { name: 'SOCIAL.INSTAGRAM', icon: 'instagram', url: environment.socials.instagram },
    { name: 'SOCIAL.TWITTER', icon: 'twitter', url: environment.socials.twitter },
    { name: 'SOCIAL.YOUTUBE', icon: 'youtube', url: environment.socials.youtube },
    { name: 'SOCIAL.LINKEDIN', icon: 'linkedin', url: environment.socials.linkedin },
    { name: 'SOCIAL.FLICKR', icon: 'flickr', url: environment.socials.flickr },
    { name: 'SOCIAL.TELEGRAM', icon: 'telegram', url: environment.socials.telegram },
  ];

  showSocials = computed(() => this.socials.some((social) => social.url));
}
